import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/Profile"
import UserSetting from "../pages/Users/UserList"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"

// Tracking
import Tracking from "../pages/Tracking/index"
import TrackingList from "../pages/Tracking/TrackingList"
import TrackingEdit from "../pages/Tracking/TrackingEdit"
import TrackingView from "../pages/Tracking/TrackingView"

const authProtectedRoutes = [
  { path: "/tracking-list", component: TrackingList, isAdmin: true },
  {
    path: "/edit-tracking/:trackingUid?",
    component: TrackingEdit,
  },
  // //profile
  { path: "/profile", component: UserProfile },
  { path: "/user-setting", component: UserSetting, isAdmin: true },
]

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/search-tracking", component: Tracking, layout: true },
  { path: "/view-tracking", component: TrackingView, layout: true },
  // this route should be at the end of all other routes

  {
    path: "*",
    exact: true,
    // eslint-disable-next-line react/display-name
    component: () => <Redirect to="/search-tracking" />,
  },
]

export { publicRoutes, authProtectedRoutes }
